import { MainContentLayout } from 'shared/ui/layout';

import { AddHub } from 'features/hub/add';

export function AddHubPage() {
  return <MainContentLayout element={<AddHub />} />;
}
